module.exports = __webpack_public_path__ + "static/img/delivery_on.da9ec556.svg";